export function timeDifference(
  givenTimeString: string,
  difference: number = 1000,
): boolean {
  const givenTime = new Date(givenTimeString);
  const currentTime = new Date();
  const timeDifference = Math.abs(currentTime.getTime() - givenTime.getTime());
  return timeDifference < difference;
}
